import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './styled';
import Logo from '../../assets/logo_navbar.png';
import Dani1000 from '../../assets/img/dani_1000.jpg';
import DaniLivros from '../../assets/img/dani_livros.jpg';
import DanizinhaRindo from '../../assets/img/Danizinha_rindo.png';
import Depoimento1 from '../../assets/img/depoimentos/depoimento_1.jpg';
import Depoimento2 from '../../assets/img/depoimentos/depoimento_2.png';
import Depoimento3 from '../../assets/img/depoimentos/depoimento_3.png';
import Depoimento4 from '../../assets/img/depoimentos/depoimento_4.png';
import Depoimento5 from '../../assets/img/depoimentos/depoimento_5.png';
import Depoimento6 from '../../assets/img/depoimentos/depoimento_6.png';
import DepoimentoUerj1 from '../../assets/img/depoimentos_planos_uerj/depoimento 1.jpeg';
import DepoimentoUerj2 from '../../assets/img/depoimentos_planos_uerj/depoimento 2.jpeg';
import DepoimentoUerj5 from '../../assets/img/depoimentos_planos_uerj/depoimento 5.jpeg';
import DepoimentoUerj6 from '../../assets/img/depoimentos_planos_uerj/depoimento 6.jpeg';
import ModalCadastro from '../../components/ModalCadastro';
import ModalCheckoutPlano from '../../components/ModalCheckoutPlano';
import api from '../../services/api';

const depoimentos = [
  Depoimento1,
  Depoimento2,
  Depoimento3,
  Depoimento4,
  Depoimento5,
  Depoimento6,
  DepoimentoUerj1,
  DepoimentoUerj2,
  DepoimentoUerj5,
  DepoimentoUerj6
];

function LandingPage() {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const [checkoutModal, setCheckoutModal] = useState({ open: false, plano: '' });
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showMorePremium, setShowMorePremium] = useState(false);
  const [openFAQItems, setOpenFAQItems] = useState({});
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const menuRef = useRef(null);
  const autoplayRef = useRef(null);
  const [precos, setPrecos] = useState({
    essencial: { preco: 119.4, quant_parcelas: 12 },
    plus: { preco: 209.4, quant_parcelas: 12 },
    vip: { preco: 447.2, quant_parcelas: 12 },
    premium: { preco: 1321.53, quant_parcelas: 12 }
  });
  const [loadingPrecos, setLoadingPrecos] = useState(true);

  const handleLoginClick = () => {
    history.push('/login');
  };

  const handleZoomClick = () => {
    history.push('/planos-uerj');
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleComprarPlano = (plano) => {
    setCheckoutModal({ open: true, plano });
  };

  const toggleMobileMenu = (e) => {
    // Impedir que o evento se propague para o documento
    if (e) {
      e.stopPropagation();
    }
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleFAQItem = (index) => {
    setOpenFAQItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // Referência para o botão hambúrguer
  const hamburgerRef = useRef(null);

  // Fechar o menu ao clicar fora dele
  useEffect(() => {
    function handleClickOutside(event) {
      // Verificar se o clique foi fora do menu e não foi no botão hambúrguer
      if (menuRef.current && !menuRef.current.contains(event.target) &&
        hamburgerRef.current && !hamburgerRef.current.contains(event.target) &&
        mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileMenuOpen]);

  useEffect(() => {
    autoplayRef.current = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % depoimentos.length);
    }, 4000);
    return () => clearInterval(autoplayRef.current);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const resetAutoplay = () => {
    clearInterval(autoplayRef.current);
    autoplayRef.current = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % depoimentos.length);
    }, 4000);
  };

  const goToSlide = (idx) => {
    setCurrentSlide(idx);
    resetAutoplay();
  };

  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? depoimentos.length - 1 : prev - 1);
    resetAutoplay();
  };

  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % depoimentos.length);
    resetAutoplay();
  };

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Observar todas as seções
    const sections = document.querySelectorAll('[data-reveal]');
    sections.forEach((section) => {
      section.style.opacity = '0';
      section.style.transform = 'translateY(50px)';
      section.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Buscar preços dos planos
  const buscarPrecos = async () => {
    try {
      const response = await api.get('/precos-planos');
      if (response.data) {
        setPrecos(response.data);
      }
    } catch (err) {
      console.error('Erro ao buscar preços:', err);
      // Manter valores padrão em caso de erro
    } finally {
      setLoadingPrecos(false);
    }
  };

  // Buscar preços ao carregar a página
  useEffect(() => {
    buscarPrecos();
  }, []);

  return (
    <>
      <S.GlobalStyle />
      <S.Container>
      <S.Header>
        <S.Nav>
          <S.Logo>
            <img src={Logo} alt="Logo" />
          </S.Logo>
          <S.NavLinks>
            <a href="#inicio" onClick={(e) => { e.preventDefault(); scrollToSection('inicio'); }}>Início</a>
            <a href="#como-funciona" onClick={(e) => { e.preventDefault(); scrollToSection('como-funciona'); }}>Como Funciona</a>
            <a href="#ebook" onClick={(e) => { e.preventDefault(); scrollToSection('ebook'); }}>E-book</a>
            <a href="#cursos" onClick={(e) => { e.preventDefault(); scrollToSection('cursos'); }}>Cursos Presenciais</a>
            <a href="#planos" onClick={(e) => { e.preventDefault(); scrollToSection('planos'); }}>Planos</a>
            <a href="#curso-zoom" onClick={(e) => { e.preventDefault(); scrollToSection('curso-zoom'); }}>Curso UERJ</a>
            <a href="#depoimentos" onClick={(e) => { e.preventDefault(); scrollToSection('depoimentos'); }}>Depoimentos</a>
            <a href="#trajetoria" onClick={(e) => { e.preventDefault(); scrollToSection('trajetoria'); }}>Trajetória</a>
            <a href="#perguntas" onClick={(e) => { e.preventDefault(); scrollToSection('perguntas'); }}>Perguntas</a>
            <a href="#regulamentos" onClick={(e) => { e.preventDefault(); scrollToSection('regulamentos'); }}>Regulamentos</a>
            <a href="#contato" onClick={(e) => { e.preventDefault(); scrollToSection('contato'); }}>Contato</a>
          </S.NavLinks>
          <S.MobileMenuContainer>
            <S.HamburgerButton ref={hamburgerRef} className="hamburger-button" isOpen={mobileMenuOpen} onClick={toggleMobileMenu}>
              <span></span>
              <span></span>
              <span></span>
            </S.HamburgerButton>
            <S.MobileMenu ref={menuRef} isOpen={mobileMenuOpen}>
              <S.MobileLoginButton onClick={handleLoginClick}>
                Fazer Login
              </S.MobileLoginButton>
              <S.MobileMenuDivider />
              <a href="#inicio" onClick={(e) => { e.preventDefault(); scrollToSection('inicio'); setMobileMenuOpen(false); }}>Início</a>
              <a href="#como-funciona" onClick={(e) => { e.preventDefault(); scrollToSection('como-funciona'); setMobileMenuOpen(false); }}>Como Funciona</a>
              <a href="#ebook" onClick={(e) => { e.preventDefault(); scrollToSection('ebook'); setMobileMenuOpen(false); }}>E-book</a>
              <a href="#cursos" onClick={(e) => { e.preventDefault(); scrollToSection('cursos'); setMobileMenuOpen(false); }}>Cursos Presenciais</a>
              <a href="#planos" onClick={(e) => { e.preventDefault(); scrollToSection('planos'); setMobileMenuOpen(false); }}>Planos</a>
              <a href="#curso-zoom" onClick={(e) => { e.preventDefault(); scrollToSection('curso-zoom'); setMobileMenuOpen(false); }}>Curso UERJ</a>
              <a href="#depoimentos" onClick={(e) => { e.preventDefault(); scrollToSection('depoimentos'); setMobileMenuOpen(false); }}>Depoimentos</a>
              <a href="#trajetoria" onClick={(e) => { e.preventDefault(); scrollToSection('trajetoria'); setMobileMenuOpen(false); }}>Trajetória</a>
              <a href="#perguntas" onClick={(e) => { e.preventDefault(); scrollToSection('perguntas'); setMobileMenuOpen(false); }}>Perguntas</a>
              <a href="#regulamentos" onClick={(e) => { e.preventDefault(); scrollToSection('regulamentos'); setMobileMenuOpen(false); }}>Regulamentos</a>
              <a href="#contato" onClick={(e) => { e.preventDefault(); scrollToSection('contato'); setMobileMenuOpen(false); }}>Contato</a>
            </S.MobileMenu>
          </S.MobileMenuContainer>
          <S.LoginButton onClick={handleLoginClick}>
            Fazer Login
          </S.LoginButton>
        </S.Nav>
      </S.Header>

      <S.HeroSection id="inicio" data-reveal>
        <S.HeroContent>
          <S.HeroTextColumn>
            <S.HeroTitle>
              Aprenda
              <br />
              a escrever
              <br />
              de verdade
              <br />
              <S.Highlight>para sua
                <br />
                nota 1000!</S.Highlight>
            </S.HeroTitle>
            <S.HeroSubtitle>
              Matrículas abertas!
            </S.HeroSubtitle>
            <S.HeroButtons>
              <S.PrimaryButton onClick={(e) => { e.preventDefault(); scrollToSection('planos'); }}>
                Você Ganhou 01 Correção de Redação
              </S.PrimaryButton>
            </S.HeroButtons>
            <S.HeroCoursesButtons>
              <S.HeroCoursesButtonsRow>
                <S.HeroCourseButton tipo="presencial" onClick={(e) => { e.preventDefault(); scrollToSection('cursos'); }}>
                  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18M7,8.5H16V7H7V8.5Z" />
                  </svg>
                  Curso Presencial
                </S.HeroCourseButton>
                <S.HeroCourseButton tipo="online" onClick={(e) => { e.preventDefault(); scrollToSection('cursos'); }}>
                  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                    <path d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" />
                  </svg>
                  Curso On-line
                </S.HeroCourseButton>
              </S.HeroCoursesButtonsRow>
              <S.HeroUrgentBanner>
                Vagas Limitadas!
              </S.HeroUrgentBanner>
            </S.HeroCoursesButtons>
          </S.HeroTextColumn>
          <S.HeroImageColumn>
            <img
              src={DanizinhaRindo}
              alt="Danizinha - Professora de Redação"
              width="400"
              height="auto"
            />
          </S.HeroImageColumn>
        </S.HeroContent>
      </S.HeroSection>

      <S.ComoFuncionaSection id="como-funciona" data-reveal>
        <S.ComoFuncionaContent>
          <S.ComoFuncionaTitle>COMO FUNCIONA</S.ComoFuncionaTitle>
          <S.ComoFuncionaHeaderGrid>
            <S.ComoFuncionaSubtitle>
              <strong>SIMPLES E<br />PRÁTICO</strong>
            </S.ComoFuncionaSubtitle>
            <S.ComoFuncionaDivider />
            <S.ComoFuncionaDescription>
              Nossa plataforma é única e intuitiva para tornar seu aprendizado mais dinâmico. Aqui você recebe sua redação comentada e ainda consegue acompanhar seu quadro de evolução.
            </S.ComoFuncionaDescription>
          </S.ComoFuncionaHeaderGrid>
          <S.PassosGrid>
            <S.PassoCard>
              <S.PassoIcon>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                </svg>
              </S.PassoIcon>
              <S.PassoTitle>CADASTRE-SE NA NOSSA PLATAFORMA</S.PassoTitle>
              <S.PassoDescription>
                Faça seu <strong>cadastro gratuito</strong>, escolha um de nossos <strong>planos</strong> e comece a treinar.
              </S.PassoDescription>
            </S.PassoCard>
            <S.PassoCard>
              <S.PassoIcon>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M17,17H7V15H17V17M17,13H7V11H17V13M17,9H7V7H17V9Z" />
                </svg>
              </S.PassoIcon>
              <S.PassoTitle>ESCOLHA UM TEMA DA REDAÇÃO</S.PassoTitle>
              <S.PassoDescription>
                Temos um banco com <strong>mais de 300 temas</strong> e diversas áreas para você poder treinar sua redação rumo à <strong>nota máxima</strong>.
              </S.PassoDescription>
            </S.PassoCard>
            <S.PassoCard>
              <S.PassoIcon>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
                </svg>
              </S.PassoIcon>
              <S.PassoTitle>ENVIE SUA REDAÇÃO E RECEBA SUA CORREÇÃO COMENTADA.</S.PassoTitle>
              <S.PassoDescription>
                Nós fazemos uma <strong>correção comentada e detalhada</strong> para que você possa <strong>aprender e escrever de verdade</strong>.
              </S.PassoDescription>
            </S.PassoCard>
            <S.PassoCard>
              <S.PassoIcon>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z" />
                </svg>
              </S.PassoIcon>
              <S.PassoTitle>DASHBOARD COM QUADRO EVOLUCIONAL DO ALUNO</S.PassoTitle>
              <S.PassoDescription>
                Acompanhe toda sua <strong>evolução na escrita</strong> rumo à <strong>nota máxima</strong>.
              </S.PassoDescription>
            </S.PassoCard>
          </S.PassosGrid>
          <S.ProvaSection>
            <S.ProvaSocial>+ de 20.000 redações corrigidas!</S.ProvaSocial>
          </S.ProvaSection>
          <S.QueroSerAprovadoButton onClick={handleOpenModal}>
            LIBERAR MINHA CORREÇÃO GRÁTIS
          </S.QueroSerAprovadoButton>
        </S.ComoFuncionaContent>
      </S.ComoFuncionaSection>

      <S.EbookSection id="ebook" data-reveal>
        <S.EbookContent>
          <S.EbookImageContainer>
            <img src="./capa_nota1000.png" alt="E-book da Clara - Nota 1000" />
          </S.EbookImageContainer>
          <S.EbookTextContent>
            <S.EbookTitle>E-book da Clara</S.EbookTitle>
            <S.EbookSubtitle>O segredo por trás da nota 1000 no ENEM 2024</S.EbookSubtitle>
            <S.EbookDescription>
              Descubra os métodos e estratégias que levaram Clara da Barra de Oliveira a conquistar a nota máxima na redação do ENEM 2024, sendo uma entre apenas 12 candidatos a alcançar esse feito extraordinário.
            </S.EbookDescription>
            <S.EbookHighlight>
              Você recebe este e-book gratuitamente ao assinar o plano Premium!
            </S.EbookHighlight>
            <S.EbookDescription>
              Neste e-book exclusivo, você terá acesso aos insights, técnicas de escrita e dicas práticas que fizeram a diferença na jornada da Clara rumo à excelência na redação do ENEM.
            </S.EbookDescription>
            <S.EbookButton onClick={handleOpenModal}>
              Comprar Agora
            </S.EbookButton>
          </S.EbookTextContent>
        </S.EbookContent>
      </S.EbookSection>

      <S.CursosSection id="cursos" data-reveal>
        <S.CursosContent>
          <S.CursosHeader>
            <S.VagasAbertasBanner>
              <S.VagasIcon>
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18M7,8.5H16V7H7V8.5Z" />
                </svg>
              </S.VagasIcon>
              <S.VagasTexto>
                <span>VAGAS ABERTAS PARA O PRESENCIAL E ON-LINE!</span>
                <span>Garanta sua vaga agora mesmo</span>
              </S.VagasTexto>
            </S.VagasAbertasBanner>
            <S.CursosTitle>CONHEÇA NOSSOS CURSOS</S.CursosTitle>
            <S.CursosSubtitle>
              Aprenda a escrever de verdade com acompanhamento personalizado da professora Danielle Velasco e sua equipe!
            </S.CursosSubtitle>
          </S.CursosHeader>
          <S.CursosGrid>
            <S.CursoCard tipo="presencial">
              <S.CursoCardBadge tipo="presencial">Vagas Limitadas!</S.CursoCardBadge>
              <S.CursoCardHeader>
                <S.CursoIcon tipo="presencial">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18M7,8.5H16V7H7V8.5Z" />
                  </svg>
                </S.CursoIcon>
                <S.CursoTitulo>Curso Presencial</S.CursoTitulo>
              </S.CursoCardHeader>
              <S.CursoFeaturesList>
                <S.CursoFeature>1h e 30 minutos uma vez na semana na turma escolhida.</S.CursoFeature>
                <S.CursoFeature>Material exclusivo utilizado em sala pensado pela professora Danielle Velasco.</S.CursoFeature>
                <S.CursoFeature>Monitoria semanal.</S.CursoFeature>
                <S.CursoFeature>Mentoria semanal com professor (a partir de maio/2026) 1 vez na semana com grupos reduzidos de até 3 alunos.</S.CursoFeature>
                <S.CursoFeature>Correção de dois temas semanais.</S.CursoFeature>
                <S.CursoFeature>A correção é feita pela equipe de professores especializados na prova de redação do Enem e supervisionado pela professora Danielle.</S.CursoFeature>
                <S.CursoFeature>Acompanhamento individualizado pela coordenação com orientação específica.</S.CursoFeature>
                <S.CursoFeature>Acesso a nossa plataforma de correção própria e exclusiva, com todos os erros apontados e comentados.</S.CursoFeature>
                <S.CursoFeature>Aulas on-line de Filosofia/Sociologia/Geografia (de acordo com a necessidade de repertório).</S.CursoFeature>
                <S.CursoFeature>Clube da leitura para ampliar repertório.</S.CursoFeature>
                <S.CursoFeature>Bônus exclusivo: mentoria 24h por dia com a (IA) Danizinha na nossa plataforma.</S.CursoFeature>
              </S.CursoFeaturesList>
              <S.CursoResultado>
                <p><strong>Resultado esperado:</strong> o aluno aprende a escrever de forma autoral dentro das competências ENEM para conquistar a sua nota máxima na redação.</p>
              </S.CursoResultado>
              <S.CursoWhatsAppButton
                tipo="presencial"
                href="https://wa.me/5521969570209?text=Olá! Gostaria de saber mais sobre o CURSO PRESENCIAL de redação da Danielle Velasco."
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" />
                </svg>
                Matricule-se pelo WhatsApp
              </S.CursoWhatsAppButton>
            </S.CursoCard>

            <S.CursoCard tipo="online">
              <S.CursoCardBadge tipo="online">Vagas Limitadas!</S.CursoCardBadge>
              <S.CursoCardHeader>
                <S.CursoIcon tipo="online">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" />
                  </svg>
                </S.CursoIcon>
                <S.CursoTitulo>Curso On-line pelo Zoom</S.CursoTitulo>
              </S.CursoCardHeader>
              <S.CursoFeaturesList>
                <S.CursoFeature>1h e 30 minutos uma vez pelo Zoom.</S.CursoFeature>
                <S.CursoFeature>Material exclusivo utilizado em sala pensado pela professora Danielle Velasco.</S.CursoFeature>
                <S.CursoFeature>Monitoria semanal.</S.CursoFeature>
                <S.CursoFeature>Mentoria semanal com professor (a partir de maio/2026) 1 vez na semana com grupos reduzidos de até 3 alunos.</S.CursoFeature>
                <S.CursoFeature>Correção de dois temas semanais.</S.CursoFeature>
                <S.CursoFeature>A correção é feita pela equipe de professores especializados na prova de redação do Enem e supervisionado pela professora Danielle.</S.CursoFeature>
                <S.CursoFeature>Acompanhamento individualizado pela coordenação com orientação específica.</S.CursoFeature>
                <S.CursoFeature>Acesso a nossa plataforma de correção própria e exclusiva, com todos os erros apontados e comentados.</S.CursoFeature>
                <S.CursoFeature>Aulas on-line de Filosofia/Sociologia/Geografia (de acordo com a necessidade de repertório).</S.CursoFeature>
                <S.CursoFeature>Clube da leitura para ampliar repertório.</S.CursoFeature>
                <S.CursoFeature>Bônus exclusivo: mentoria 24h por dia com a (IA) Danizinha na nossa plataforma.</S.CursoFeature>
              </S.CursoFeaturesList>
              <S.CursoResultado>
                <p><strong>Resultado esperado:</strong> o aluno aprende a escrever de forma autoral dentro das competências ENEM para conquistar a sua nota máxima na redação.</p>
              </S.CursoResultado>
              <S.CursoWhatsAppButton
                tipo="online"
                href="https://wa.me/5521969570209?text=Olá! Gostaria de saber mais sobre o CURSO ON-LINE PELO ZOOM de redação da Danielle Velasco."
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" />
                </svg>
                Matricule-se pelo WhatsApp
              </S.CursoWhatsAppButton>
            </S.CursoCard>
          </S.CursosGrid>
        </S.CursosContent>
      </S.CursosSection>

      <S.PlanosSection id="planos" data-reveal>
        <S.PlanosContent>
          <S.PlanosHeader>
            <S.PlanosTitle>PACOTES PARA A SUA</S.PlanosTitle>
            <S.PlanosTitle>NOTA MÁXIMA</S.PlanosTitle>
            <S.PlanosSubtitle>
              Busca treinar e melhorar sua redação?<br />
              Veja nossos pacotes e planos disponíveis.
            </S.PlanosSubtitle>
            <S.PlanosCorrecaoButton onClick={handleOpenModal}>
              LIBERAR MINHA CORREÇÃO
            </S.PlanosCorrecaoButton>
          </S.PlanosHeader>
          <S.PlanosGrid>
            <S.PlanoCard>
              <S.PlanoHeader>
                <S.PlanoTipo>PREMIUM</S.PlanoTipo>
              </S.PlanoHeader>
              <S.PlanoPreco>
                <S.PrecoValor>{precos.premium.quant_parcelas}x R${(precos.premium.preco / precos.premium.quant_parcelas).toFixed(2).replace('.', ',')}</S.PrecoValor>
                <S.PrecoTotal>Total: R${precos.premium.preco.toFixed(2).replace('.', ',')}</S.PrecoTotal>
              </S.PlanoPreco>
              <S.PlanoFeatures>
                <S.Feature>60 Correções por IA</S.Feature>
                <S.Feature>20 Aulas inéditas gravadas com conteúdo e dicas exclusivas</S.Feature>
                <S.Feature>E-book nota 1000 da Clara da Barra</S.Feature>
                {showMorePremium && (
                  <>
                    <S.Feature>+6 Correções premium com professores da banca</S.Feature>
                    <S.Feature>Mentora Danizinha (IA)</S.Feature>
                    <S.Feature>Correção em até 2 minutos</S.Feature>
                    <S.Feature>Banco de 135 temas</S.Feature>
                    <S.Feature>Acesso a nosso E-book</S.Feature>
                    <S.Feature>2 Mentorias individuais com a equipe da Danielle Velasco</S.Feature>
                    <S.Feature>Aulas interdisciplinares gravadas</S.Feature>
                    <S.Feature>1 Aulão com a professora Danielle Velasco (A data será repassada)</S.Feature>
                    <S.Feature>Plano anual</S.Feature>
                  </>
                )}
                <S.VerMaisButton onClick={() => setShowMorePremium(!showMorePremium)}>
                  {showMorePremium ? 'Ver menos' : 'Ver mais'}
                </S.VerMaisButton>
              </S.PlanoFeatures>
              <S.PlanoButton style={{ marginTop: '0rem' }} onClick={() => handleComprarPlano('PREMIUM')}>COMPRE AGORA</S.PlanoButton>
              <S.CorrecaoButton onClick={handleOpenModal}>LIBERAR MINHA CORREÇÃO</S.CorrecaoButton>
            </S.PlanoCard>

            <S.PlanoCard destaque>
              <S.PlanoHeader>
                <S.PlanoTipo>VIP</S.PlanoTipo>
              </S.PlanoHeader>
              <S.PlanoPreco>
                <S.PrecoValor>{precos.vip.quant_parcelas}x R${(precos.vip.preco / precos.vip.quant_parcelas).toFixed(2).replace('.', ',')}</S.PrecoValor>
                <S.PrecoTotal>Total: R${precos.vip.preco.toFixed(2).replace('.', ',')}</S.PrecoTotal>
              </S.PlanoPreco>
              <S.PlanoFeatures>
                <S.Feature>45 correções por IA</S.Feature>
                <S.Feature>Mentora Danizinha (IA)</S.Feature>
                <S.Feature>Correção em até 2 minutos</S.Feature>
                <S.Feature>Banco de 90 temas</S.Feature>
                <S.Feature>Acesso a nosso E-book</S.Feature>
                <S.Feature>Plano anual</S.Feature>
                <S.FeatureSpacer></S.FeatureSpacer>
              </S.PlanoFeatures>
              <S.PlanoButton onClick={() => handleComprarPlano('VIP')}>COMPRE AGORA</S.PlanoButton>
              <S.CorrecaoButton onClick={handleOpenModal}>LIBERAR MINHA CORREÇÃO</S.CorrecaoButton>
            </S.PlanoCard>

            <S.PlanoCard>
              <S.PlanoHeader>
                <S.PlanoTipo>PLUS</S.PlanoTipo>
              </S.PlanoHeader>
              <S.PlanoPreco>
                <S.PrecoValor>{precos.plus.quant_parcelas}x R${(precos.plus.preco / precos.plus.quant_parcelas).toFixed(2).replace('.', ',')}</S.PrecoValor>
                <S.PrecoTotal>Total: R${precos.plus.preco.toFixed(2).replace('.', ',')}</S.PrecoTotal>
              </S.PlanoPreco>
              <S.PlanoFeatures>
                <S.Feature>30 correções por IA</S.Feature>
                <S.Feature>Mentora Danizinha (IA)</S.Feature>
                <S.Feature>Correção em até 2 minutos</S.Feature>
                <S.Feature>Banco de 60 temas</S.Feature>
                <S.Feature>Plano anual</S.Feature>
                <S.FeatureSpacer></S.FeatureSpacer>
                <S.FeatureSpacer></S.FeatureSpacer>
              </S.PlanoFeatures>
              <S.PlanoButton onClick={() => handleComprarPlano('PLUS')}>COMPRE AGORA</S.PlanoButton>
              <S.CorrecaoButton onClick={handleOpenModal}>LIBERAR MINHA CORREÇÃO</S.CorrecaoButton>
            </S.PlanoCard>
            <S.PlanoCard>
              <S.PlanoHeader>
                <S.PlanoTipo>ESSENCIAL</S.PlanoTipo>
              </S.PlanoHeader>
              <S.PlanoPreco>
                <S.PrecoValor>{precos.essencial.quant_parcelas}x R${(precos.essencial.preco / precos.essencial.quant_parcelas).toFixed(2).replace('.', ',')}</S.PrecoValor>
                <S.PrecoTotal>Total: R${precos.essencial.preco.toFixed(2).replace('.', ',')}</S.PrecoTotal>
              </S.PlanoPreco>
              <S.PlanoFeatures>
                <S.Feature>15 correções por IA</S.Feature>
                <S.Feature>Mentora Danizinha (IA)</S.Feature>
                <S.Feature>Correção em até 2 minutos</S.Feature>
                <S.Feature>Banco de 40 temas</S.Feature>
                <S.Feature>Plano anual</S.Feature>
                <S.FeatureSpacer></S.FeatureSpacer>
                <S.FeatureSpacer></S.FeatureSpacer>
              </S.PlanoFeatures>
              <S.PlanoButton onClick={() => handleComprarPlano('ESSENCIAL')}>COMPRE AGORA</S.PlanoButton>
              <S.CorrecaoButton onClick={handleOpenModal}>LIBERAR MINHA CORREÇÃO</S.CorrecaoButton>
            </S.PlanoCard>
          </S.PlanosGrid>
        </S.PlanosContent>
      </S.PlanosSection>

      <S.ZoomCtaSection id="curso-zoom" data-reveal>
        <S.ZoomCtaContent>
          <S.ZoomCtaTextBlock>
            <S.ZoomCtaBadge>Curso ao vivo pelo Zoom</S.ZoomCtaBadge>
            <S.ZoomCtaTitle>Turma especial UERJ com a Danielle Velasco</S.ZoomCtaTitle>
            <S.ZoomCtaDescription>
              Aulas on-line semanais com acompanhamento da equipe e correções supervisionadas.
              Ideal para quem quer escrever de forma autoral e garantir a nota máxima na UERJ.
            </S.ZoomCtaDescription>
            <S.ZoomCtaActions>
              <S.ZoomCtaPrimaryButton onClick={handleZoomClick}>
                Quero ver o curso pelo Zoom
              </S.ZoomCtaPrimaryButton>
            </S.ZoomCtaActions>
          </S.ZoomCtaTextBlock>
          <S.ZoomCtaInfoCard>
            <S.ZoomCtaInfoTitle>O que está incluso</S.ZoomCtaInfoTitle>
            <S.ZoomCtaInfoList>
              <li>Aulas ao vivo semanais de 1h30</li>
              <li>Mentoria e correções supervisionadas</li>
              <li>Plataforma exclusiva com feedback completo</li>
              <li>Clube de leitura e aulas interdisciplinares</li>
              <li>Material exclusivo e acompanhamento da coordenação</li>
            </S.ZoomCtaInfoList>
            <S.ZoomCtaInfoButton onClick={handleZoomClick}>
              Ver detalhes completos do curso
            </S.ZoomCtaInfoButton>
            <S.ZoomCtaInfoFooter type="button" onClick={handleZoomClick}>
              Início das aulas: 08 de maio de 2026
            </S.ZoomCtaInfoFooter>
          </S.ZoomCtaInfoCard>
        </S.ZoomCtaContent>
      </S.ZoomCtaSection>

      <S.ConfiancaSection id="confianca" data-reveal>
        <S.ConfiancaContent>
          <S.ConfiancaTitle>CONFIANÇA E SEGURANÇA</S.ConfiancaTitle>
          <S.GarantiaContainer>
            <S.GarantiaTexto>
              <S.GarantiaIcon>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.6 14.8,10V11.5C15.4,11.5 16,12.4 16,13V16C16,17.4 15.4,18 14.8,18H9.2C8.6,18 8,17.4 8,16V13C8,12.4 8.6,11.5 9.2,11.5V10C9.2,8.6 10.6,7 12,7M12,8.2C11.2,8.2 10.5,8.7 10.5,10V11.5H13.5V10C13.5,8.7 12.8,8.2 12,8.2Z" />
                </svg>
              </S.GarantiaIcon>
              <S.GarantiaTextoContent>
                <S.GarantiaTitulo>SATISFAÇÃO GARANTIDA</S.GarantiaTitulo>
                <S.GarantiaDescricao>
                  Ou seu dinheiro de volta em 7 dias.
                </S.GarantiaDescricao>
              </S.GarantiaTextoContent>
            </S.GarantiaTexto>
          </S.GarantiaContainer>
          <S.SelosContainer>
            <S.SeloItem>
              <S.SeloIcon>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22S19,14.25 19,9A7,7 0 0,0 12,2Z" />
                </svg>
              </S.SeloIcon>
              <S.SeloTexto>Pagamento 100% Seguro.</S.SeloTexto>
            </S.SeloItem>
            <S.SeloItem>
              <S.SeloIcon>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
                </svg>
              </S.SeloIcon>
              <S.SeloTexto>Pix, Cartão de Crédito e Débito.</S.SeloTexto>
            </S.SeloItem>
          </S.SelosContainer>
        </S.ConfiancaContent>
      </S.ConfiancaSection>

      <S.RegulamentosSection data-reveal>
        <S.RegulamentosContent>
          <S.TodosOsPlanosTitle>TODOS OS PLANOS INCLUEM:</S.TodosOsPlanosTitle>
          <S.RecursosIncluidos>
            <S.RecursoIncluido>
              <S.RecursoIcon>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  <path d="M8,12V14H16V12H8M8,16V18H13V16H8Z" />
                </svg>
              </S.RecursoIcon>
              <S.RecursoTitulo>CORREÇÃO INDIVIDUALIZADA E DETALHADA.</S.RecursoTitulo>
            </S.RecursoIncluido>
            <S.RecursoIncluido>
              <S.RecursoIcon>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,19H5V5H19V19Z" />
                  <path d="M16.5,16.25L19.36,12.27L18.54,11.72L16.5,14.75L15.43,13.68L14.68,14.43L16.5,16.25M6.95,11.5L11.5,9.5L16.05,11.5L11.5,13.5L6.95,11.5M7,8.5H16V7H7V8.5Z" />
                </svg>
              </S.RecursoIcon>
              <S.RecursoTitulo>BANCO DE TEMAS.</S.RecursoTitulo>
            </S.RecursoIncluido>
            <S.RecursoIncluido>
              <S.RecursoIcon>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" />
                </svg>
              </S.RecursoIcon>
              <S.RecursoTitulo>MATERIAL DE APOIO ATUALIZADO PARA O ENEM.</S.RecursoTitulo>
            </S.RecursoIncluido>
            <S.RecursoIncluido>
              <S.RecursoIcon>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z" />
                </svg>
              </S.RecursoIcon>
              <S.RecursoTitulo>SUGESTÃO DE MELHORIA.</S.RecursoTitulo>
            </S.RecursoIncluido>
            <S.RecursoIncluido>
              <S.RecursoIcon>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z" />
                </svg>
              </S.RecursoIcon>
              <S.RecursoTitulo>EVOLUÇÃO DO ALUNO ATRAVÉS DO DASHBOARD.</S.RecursoTitulo>
            </S.RecursoIncluido>
          </S.RecursosIncluidos>

        </S.RegulamentosContent>
      </S.RegulamentosSection>

      <S.TestimonialsSection id="depoimentos" data-reveal>
        <S.TestimonialsTitle>O que nossos <span>alunos</span> dizem</S.TestimonialsTitle>
        <S.TestimonialsSubtitle>Depoimentos reais de quem já faz parte do nosso curso</S.TestimonialsSubtitle>
        <S.CarouselContainer>
          <S.CarouselViewport>
            <S.CarouselSlide
              isActive={false}
              onClick={() => goToSlide(currentSlide === 0 ? depoimentos.length - 1 : currentSlide - 1)}
            >
              <img src={depoimentos[currentSlide === 0 ? depoimentos.length - 1 : currentSlide - 1]} alt="Depoimento anterior" />
            </S.CarouselSlide>
            <S.CarouselSlide isActive={true}>
              <img src={depoimentos[currentSlide]} alt={`Depoimento ${currentSlide + 1}`} />
            </S.CarouselSlide>
            <S.CarouselSlide
              isActive={false}
              onClick={() => goToSlide((currentSlide + 1) % depoimentos.length)}
            >
              <img src={depoimentos[(currentSlide + 1) % depoimentos.length]} alt="Próximo depoimento" />
            </S.CarouselSlide>
          </S.CarouselViewport>
          <S.CarouselControls>
            <S.CarouselButton onClick={prevSlide}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
            </S.CarouselButton>
            <S.CarouselDots>
              {depoimentos.map((_, idx) => (
                <S.CarouselDot key={idx} active={idx === currentSlide} onClick={() => goToSlide(idx)} />
              ))}
            </S.CarouselDots>
            <S.CarouselCounter>{currentSlide + 1} / {depoimentos.length}</S.CarouselCounter>
            <S.CarouselButton onClick={nextSlide}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
            </S.CarouselButton>
          </S.CarouselControls>
        </S.CarouselContainer>
      </S.TestimonialsSection>

      <S.TrajetoriaSection id="trajetoria" data-reveal>
        <S.TrajetoriaContent>
          <S.TrajetoriaTopSection>
            <S.TrajetoriaImage>
              <S.ImageContainer>
                <img src={Dani1000} alt="Danielle Velasco" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '20px' }} />
              </S.ImageContainer>
              <S.ProfileImage>
                <img src={DaniLivros} alt="Danielle Velasco com livros" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '15px' }} />
              </S.ProfileImage>
            </S.TrajetoriaImage>
            <S.TrajetoriaText>
              <S.TrajetoriaTitle>
                A trajetória do Curso Danielle Velasco começou muito antes de sua fundação oficial!
              </S.TrajetoriaTitle>
              <S.TrajetoriaDescription>
                Desde 2000, atuando nas mais diferentes bancas e concursos, a professora Danielle Velasco já buscava estimular a escrita verdadeira e autoral.
              </S.TrajetoriaDescription>
              <S.TrajetoriaDescription>
                Em 2010, direcionou suas aulas para o ENEM e, em 2013, na cidade de Niterói - R.J., decidiu se dedicar a cursos específicos voltados para a realização dessa prova. Assim, começou a construir e consolidar a metodologia que hoje é reconhecida por gerar resultados altamente expressivos.
              </S.TrajetoriaDescription>
              <S.TrajetoriaDescription>
                Com o desejo de expandir sua visão inovadora, em 2017, iniciou um projeto solo e, em 2018, fundou o Curso Danielle Velasco com o foco na escrita, não só para a prova do vestibular, mas para vida. Nesse mesmo ano, entre tantos excelentes resultados, um se fez marcante: <strong>sua aluna Maria Fernanda Brandão conquistou a nota 1000 na redação do ENEM.</strong>
              </S.TrajetoriaDescription>
            </S.TrajetoriaText>
          </S.TrajetoriaTopSection>
          <S.TrajetoriaBottomSection>
            <S.TrajetoriaBottomText>
              <S.TrajetoriaDescription>
                Muitos desafios tiveram de ser enfrentados durante a pandemia e, ainda assim, a professora Danielle enxergou uma oportunidade de inovar: levou sua metodologia para o ambiente digital, criando um projeto on-line com pacotes de correção e aulas virtuais, que preservam a mesma qualidade das presenciais.
              </S.TrajetoriaDescription>
              <S.ResultadosList>
                <S.ResultadosTitle>
                  Os resultados não pararam por aí! Ao longo dos anos, o Curso Danielle Velasco já contabilizou:
                </S.ResultadosTitle>
                <S.ResultadosItem>Dezenas de notas 980</S.ResultadosItem>
                <S.ResultadosItem>Centenas de notas 960</S.ResultadosItem>
                <S.ResultadosItem>Centenas de notas acima de 900</S.ResultadosItem>
              </S.ResultadosList>
              <S.ConquistaDestaque>
                <p>
                  E, em 2024, mais uma conquista: a aluna Clara da Barra de Oliveira alcançou a nota 1000, sendo uma entre os 12 únicos candidatos a alcançarem esse feito entre os 4.325.960 inscritos no exame.
                </p>
              </S.ConquistaDestaque>
              <S.TrajetoriaDescription>
                Desse modo, o Curso Danielle Velasco segue escrevendo sua história com empenho, inovação, qualidade, eficiência e resultados comprovados - transformando habilidades em competências que levam a conquistas concretas para seus alunos.
              </S.TrajetoriaDescription>
            </S.TrajetoriaBottomText>
          </S.TrajetoriaBottomSection>
        </S.TrajetoriaContent>
      </S.TrajetoriaSection>

      <S.CallToActionSection data-reveal>
        <S.CallToActionContent>
          <S.CallToActionTitle>QUER EXPERIMENTAR NOSSA CORREÇÃO INTELIGENTE?</S.CallToActionTitle>
          <S.CallToActionButton onClick={handleOpenModal}>EXPERIMENTE AGORA!</S.CallToActionButton>
        </S.CallToActionContent>
      </S.CallToActionSection>

      <S.FAQSection id="perguntas" data-reveal>
        <S.FAQContent>
          <S.FAQTitle>PERGUNTAS FREQUENTES</S.FAQTitle>
          <S.FAQSubtitle>
            Tire suas dúvidas e comece sua jornada rumo à nota 1000!
          </S.FAQSubtitle>
          <S.FAQContainer>
            <S.FAQItem>
              <S.FAQQuestion onClick={() => toggleFAQItem(0)}>
                <S.FAQQuestionText>Em quanto tempo recebo a correção?</S.FAQQuestionText>
                <S.FAQIcon isOpen={openFAQItems[0]}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                  </svg>
                </S.FAQIcon>
              </S.FAQQuestion>
              {openFAQItems[0] && (
                <S.FAQAnswer>
                  <S.FAQAnswerText>
                    Sua redação é corrigida em até 2 minutos pela nossa IA especializada!
                    Você recebe uma análise completa e detalhada de todas as competências do ENEM,
                    com sugestões personalizadas para melhorar sua escrita.
                  </S.FAQAnswerText>
                </S.FAQAnswer>
              )}
            </S.FAQItem>

            <S.FAQItem>
              <S.FAQQuestion onClick={() => toggleFAQItem(1)}>
                <S.FAQQuestionText>Posso cancelar quando quiser?</S.FAQQuestionText>
                <S.FAQIcon isOpen={openFAQItems[1]}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                  </svg>
                </S.FAQIcon>
              </S.FAQQuestion>
              {openFAQItems[1] && (
                <S.FAQAnswer>
                  <S.FAQAnswerText>
                    Oferecemos garantia de 7 dias a partir da contratação:
                    se você não ficar satisfeito com o serviço nesse período, devolvemos 100% do valor pago, sem necessidade de justificativa.
                  </S.FAQAnswerText>
                </S.FAQAnswer>
              )}
            </S.FAQItem>

            <S.FAQItem>
              <S.FAQQuestion onClick={() => toggleFAQItem(2)}>
                <S.FAQQuestionText>Para quem é este curso?</S.FAQQuestionText>
                <S.FAQIcon isOpen={openFAQItems[2]}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                  </svg>
                </S.FAQIcon>
              </S.FAQQuestion>
              {openFAQItems[2] && (
                <S.FAQAnswer>
                  <S.FAQAnswerText>
                    Este curso é para quem deseja aprimorar suas habilidades em redação de forma prática e eficiente.
                    Ideal para quem busca aprovação em vestibulares, no ENEM ou quer evoluir para alcançar a nota máxima,
                    ele foi desenvolvido para acompanhar o seu ritmo. A Danizinha (nossa IA) explica cada correção de maneira clara, didática e personalizada, guiando você do básico ao avançado passo a passo.
                  </S.FAQAnswerText>
                </S.FAQAnswer>
              )}
            </S.FAQItem>

            <S.FAQItem>
              <S.FAQQuestion onClick={() => toggleFAQItem(3)}>
                <S.FAQQuestionText>Preciso escrever toda semana?</S.FAQQuestionText>
                <S.FAQIcon isOpen={openFAQItems[3]}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                  </svg>
                </S.FAQIcon>
              </S.FAQQuestion>
              {openFAQItems[3] && (
                <S.FAQAnswer>
                  <S.FAQAnswerText>
                    Não há obrigatoriedade! Você escreve no seu ritmo e quando quiser.
                    Recomendamos pelo menos 1-2 redações por semana para um progresso consistente,
                    mas você tem total flexibilidade para usar suas correções quando for melhor para você.
                  </S.FAQAnswerText>
                </S.FAQAnswer>
              )}
            </S.FAQItem>

            <S.FAQItem>
              <S.FAQQuestion onClick={() => toggleFAQItem(4)}>
                <S.FAQQuestionText>Dá tempo até a data do ENEM?</S.FAQQuestionText>
                <S.FAQIcon isOpen={openFAQItems[4]}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                  </svg>
                </S.FAQIcon>
              </S.FAQQuestion>
              {openFAQItems[4] && (
                <S.FAQAnswer>
                  <S.FAQAnswerText>
                    Sim! Muitos alunos conseguem melhorias significativas em poucas semanas.
                    Com correções em até 2 minutos e feedback direcionado, você pode evoluir rapidamente.
                    Quanto mais cedo começar, melhor será seu desempenho no ENEM!
                  </S.FAQAnswerText>
                </S.FAQAnswer>
              )}
            </S.FAQItem>
          </S.FAQContainer>
        </S.FAQContent>
      </S.FAQSection>

      <S.CallToActionSection style={{ paddingTop: '15px', paddingBottom: '75px' }} id="regulamentos" data-reveal>
        <S.RegulamentosTitle>REGULAMENTOS</S.RegulamentosTitle>
        <S.RegulamentosDocuments>
          <S.DocumentLink
            href="./Politica de Privacidade.pdf"
            download="Politica de Privacidade.pdf"
            target="_blank"
          >
            <svg viewBox="0 0 24 24">
              <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            </svg>
            Política de Privacidade
          </S.DocumentLink>
          <S.DocumentLink
            href="./Termos de Uso de serviço e condições de uso.pdf"
            download="Termos de Uso de serviço e condições de uso.pdf"
            target="_blank"
          >
            <svg viewBox="0 0 24 24">
              <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            </svg>
            Termos de Uso e Condições
          </S.DocumentLink>
        </S.RegulamentosDocuments>
      </S.CallToActionSection>

      <S.Footer id="contato">
        <S.FooterContent>
          <S.FooterSection>
            <S.FooterLogo>
              <img src={Logo} alt="Logo" />
            </S.FooterLogo>
            <S.NewsletterForm>
              {/* <input type="email" placeholder="Digite seu email" />
              <button>ENVIAR</button> */}
            </S.NewsletterForm>
          </S.FooterSection>
          <S.FooterSection>
            {/* <h4>Menu Acesso Rápido</h4>
            <a href="#">Página de exemplo</a>
            <a href="#">Página de exemplo</a>
            <a href="#">Página de exemplo</a> */}
          </S.FooterSection>
          <S.FooterSection>
            <h4>Fale com a gente!</h4>
            <p>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" />
              </svg>
              (21) 96957-0209
            </p>
            <p>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22S19,14.25 19,9A7,7 0 0,0 12,2Z" />
              </svg>
              Rua Gavião Peixoto, 124, sala 509 - Edifício Manhattan
            </p>
            <p>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.11,4 20,4Z" />
              </svg>
              cursodaniellevelasco@gmail.com
            </p>
          </S.FooterSection>
        </S.FooterContent>
        <S.FooterBottom>
          <p>&copy; copyright 2025 Curso Danielle Velasco</p>
          <S.SocialIcons>
            <S.SocialIcon href="https://open.spotify.com/show/6OahTLB012BVlm26zUcMvn" target="_blank" rel="noopener noreferrer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.84-.179-.84-.6 0-.359.24-.66.54-.78 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.242 1.021zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.42 1.56-.299.421-1.02.599-1.559.3z" />
              </svg>
            </S.SocialIcon>
            <S.SocialIcon href="https://www.youtube.com/@cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </S.SocialIcon>
            <S.SocialIcon href="https://www.tiktok.com/@cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
              </svg>
            </S.SocialIcon>
            <S.SocialIcon href="https://wa.me/5521969570209" target="_blank" rel="noopener noreferrer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" />
              </svg>
            </S.SocialIcon>
            <S.SocialIcon href="https://www.facebook.com/cursodaniellevelasco" target="_blank" rel="noopener noreferrer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </S.SocialIcon>
          </S.SocialIcons>
        </S.FooterBottom>
      </S.Footer>
      <ModalCadastro
        isOpen={modalOpen}
        onClose={handleCloseModal}
      />
      <ModalCheckoutPlano
        isOpen={checkoutModal.open}
        onClose={() => setCheckoutModal({ open: false, plano: '' })}
        plano={checkoutModal.plano}
        precos={precos}
      />
      <S.WhatsAppButton
        href="https://wa.me/5521969570209?text=Olá! Gostaria de saber mais sobre o curso de redação da Danielle Velasco."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar no WhatsApp"
      >
        <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" />
        </svg>
      </S.WhatsAppButton>
      <S.BackToTopButton
        show={showBackToTop}
        onClick={scrollToTop}
        aria-label="Voltar ao topo"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z" />
        </svg>
      </S.BackToTopButton>
      </S.Container>
    </>
  );
}

export default LandingPage;